import { Nav, Dropdown } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import classNames from 'classnames';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';

type User = {
    isLoggedIn?: boolean;
    role?: string; 
};

type MenuProps = {
    showDownload?: boolean;
    navClass?: string;
    buttonClass?: string;
    loggedInUser?: User | null;
    onItemClick?: () => void;
};

const Menu = ({ navClass, buttonClass, showDownload, loggedInUser, onItemClick }: MenuProps) => {
    let location = useLocation();
    const navigate = useNavigate();

    
    const handleLogout = async () => {
        try {
            await signOut(auth); 
            navigate('/auth/login');
        } catch (error) {
            console.error('Logout gagal:', error);
        }
    };

    const isActiveRoute = (path: string) => {
        if (location.pathname) {
            return location.pathname.includes(path);
        }
        return false;
    };

    return (
        <Nav as="ul" className={classNames('align-items-lg-center', navClass )}>
            {/* Beranda */}
            <Nav.Item as="li">
                <NavLink to="/home" end className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                    Beranda
                </NavLink>
            </Nav.Item>

            {/* Perusahaan */}
            <Dropdown as={'li'} className="nav-item">
                <Dropdown.Toggle
                    as={Nav.Link}
                    id="navbarLandings"
                    className={classNames(isActiveRoute('/tentang') ? 'active' : '')}>
                    Perusahaan{' '}
                    <FeatherIcon icon="chevron-down" className="d-inline-block icon icon-xxs ms-1 mt-lg-0 mt-1" />
                </Dropdown.Toggle>

                <Dropdown.Menu renderOnMount className="w-100">
                    <Nav as={'ul'} navbar={false}>
                        <Nav.Item as="li">
                            <NavLink
                                to="/tentang"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Tentang
                            </NavLink>

                            <NavLink
                                to="/tentang/semua-tim"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Semua Tim
                            </NavLink>

                            <NavLink
                                to="/tentang/karir"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')}  onClick={onItemClick}>
                                Karir
                            </NavLink>

                            <NavLink
                                to="/tentang/bantuan"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Bantuan & FAQs
                            </NavLink>

                            <NavLink
                                to="/tentang/keamanan-privasi"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Keamanan & Privasi
                            </NavLink>

                            <NavLink
                                to="/tentang/sertifikasi"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Sertifikasi
                            </NavLink>
                        </Nav.Item>
                    </Nav>
                </Dropdown.Menu>
            </Dropdown>

            {/* Blog */}
            <Dropdown as={'li'} className="nav-item">
                <Dropdown.Toggle
                    as={Nav.Link}
                    id="navbarPages"
                    className={classNames(isActiveRoute('/blog') ? 'active' : '')}>
                    Blog <FeatherIcon icon="chevron-down" className="d-inline-block icon icon-xxs ms-1 mt-lg-0 mt-1" />
                </Dropdown.Toggle>

                <Dropdown.Menu renderOnMount className="w-100">
                    <Nav as={'ul'} navbar={false}>
                        <Nav.Item as="li">
                            <NavLink
                                to="/blog"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Semua Post
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <NavLink
                                to="/blog/install"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Install
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <NavLink
                                to="/blog/tutorial"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Tutorial
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <NavLink
                                to="/blog/source-code"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Source Code
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <NavLink
                                to="/blog/troubleshoot"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Troubleshoot
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <NavLink
                                to="/blog/berita-umum"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Berita Umum
                            </NavLink>
                        </Nav.Item>

                        <Nav.Item as="li">
                            <NavLink
                                to="/blog/acara"
                                end
                                className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                                Acara
                            </NavLink>
                        </Nav.Item>
                    </Nav>
                </Dropdown.Menu>
            </Dropdown>

            {/* Kontak */}
            <Nav.Item as="li">
                <NavLink to="/kontak" end className={classNames('nav-link', ({ ...isActive }) => isActive && 'active')} onClick={onItemClick}>
                    Kontak
                </NavLink>
            </Nav.Item>

            {/* Tampilkan tombol Logout jika user sudah login */}
            {loggedInUser && loggedInUser.isLoggedIn && (
                <Nav.Item as="li">
                    <button
                        onClick={handleLogout}
                        className={classNames('nav-link btn me-2 shadow-none')}>
                        Logout
                    </button>
                </Nav.Item>
            )}
        </Nav>
    );
};

export default Menu;